/**
 * LoadingSpinner Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

interface IOwnProps {
  center?: boolean;
  className?: string;
  color?: Color;
  fixed?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const classes = new BEM('loading-spinner');

export default class LoadingSpinner extends React.Component<IOwnProps, {}> {
  static defaultProps: IOwnProps = {
    color: 'accent',
    size: 'medium',
  };

  render() {
    const classModifiers = {
      [this.props.color!]: true,
      [this.props.size!]: true,
    };

    const component = <div {...classes('', classModifiers, this.props.className) }><div {...classes('icon') } /></div>;

    return !!this.props.center ? (
      <div {...classes('centered-wrapper', { fixed: !!this.props.fixed }) }>
        {component}
      </div>
    ) : component;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/feedback/LoadingSpinner/index.tsx